interface DueDateFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export const DueDateField = ({ id, label, value, onChange }: DueDateFieldProps) => (
  <div className="flex-shrink-0">
    <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
      {label}
    </label>
    <input
      id={id}
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary"
    />
  </div>
);
